<template>
  <dialog-add
    icon="inventory"
    :title="$t('create_event_promotion')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-events-promotion-first-step class="elevation-1" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/events/promotions');
    },
  },
};
</script>
